if(document.querySelector('.animation_main')){
  const animation_wrapper = document.querySelector('.animation_content_wrapper');
  const sticky = document.querySelector('.animation_scroll .sticky-element');
  const canvas = document.querySelector('canvas');
  const ctx = canvas.getContext('2d');
  const heroSequence = document.querySelector('.hero-sequence');
  const xcSequence = document.querySelector('.xc15');
  const images = [];
  let frameCount;
  if (heroSequence) {
      frameCount = 75; 
  } else if (xcSequence) {
      frameCount = 87;  
  }
  
  const resizeCanvas = () => {
    const ratio = window.devicePixelRatio || 1;
    
    if (window.innerWidth < 992) {
      canvas.width = window.innerWidth * 0.9 * ratio;
    } else {
      canvas.width = window.innerWidth * ratio;
    }
  
    if (window.location.href.indexOf("/products") !== -1) {
      canvas.height = window.innerHeight * 0.8 * ratio;
    } else {
      canvas.height = window.innerHeight * ratio;
    }
  
    canvas.style.width = `${window.innerWidth * 0.9}px`; 
    canvas.style.height = `${window.innerHeight * 0.9}px`; 
  };
  
  resizeCanvas(); 
  window.addEventListener('resize', resizeCanvas); 
  
  const prepareImages = () => {
    for (let i = 0; i < frameCount; i++) {
      const image = new Image();
      if (heroSequence) {
        image.src = `https://cdn.shopify.com/s/files/1/0712/4539/8257/files/${i.toString().padStart(2, '0')}.avif`;
      } else if (xcSequence) {
        image.src = `https://cdn.shopify.com/s/files/1/0712/4539/8257/files/${i.toString().padStart(4, '0')}.jpg`;
      }
  
      images.push(image);
  
      if (i === 0) {
        image.onload = () => {
          drawImage(0); 
        };
      }
    }
  };
  
  const drawImage = (frameIndex) => {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
  
    const image = images[frameIndex];
    const imageAspectRatio = image.width / image.height;
    const canvasAspectRatio = canvas.width / canvas.height;
  
    let drawWidth, drawHeight;
  
    if (imageAspectRatio > canvasAspectRatio) {
      drawWidth = canvas.width;
      drawHeight = canvas.width / imageAspectRatio;
    } else {
      drawHeight = canvas.height;
      drawWidth = canvas.height * imageAspectRatio;
    }
  
    const drawX = (canvas.width - drawWidth) / 2;
    const drawY = (canvas.height - drawHeight) / 2;
  
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';
  
    ctx.drawImage(image, drawX, drawY, drawWidth, drawHeight);
  };
  
  const updateContentVisibility = (frameIndex) => {
    const wrapper = document.querySelector('.animation_wrapper');
    const content = wrapper.querySelector('.animation_content');
    const scrollElements = wrapper.querySelectorAll('.animation_content');
  
    // Hide all elements by default
    scrollElements.forEach(element => {
      element.classList.remove('visible');
      animation_wrapper.style.paddingBottom = '0';
    });
  
    content.classList.remove('visible');
  
    if (window.location.pathname === "/") {
      if (frameIndex < 16) {
        wrapper.querySelector('.scroll-1').classList.add('visible');
      } else if (frameIndex >= 16 && frameIndex < 44) {
        wrapper.querySelector('.scroll-2').classList.add('visible');
      } else if (frameIndex >= 44 && frameIndex < 87) {
        wrapper.querySelector('.scroll-3').classList.add('visible');
      } else if (frameIndex >= 87 && frameIndex < 108) {
        wrapper.querySelector('.scroll-4').classList.add('visible');
      } else if (frameIndex >= 108) {
        wrapper.querySelector('.scroll-5').classList.add('visible');
        if (window.innerWidth > 991) {
          animation_wrapper.style.paddingBottom = '15%';
        }
      }
    }
  
    if (window.location.href.indexOf("/products") !== -1) {
      if (frameIndex < 30) {
        wrapper.querySelector('.scroll-1').classList.add('visible');
      } else if (frameIndex >= 30 && frameIndex < 60) {
        wrapper.querySelector('.scroll-2').classList.add('visible');
      } else if (frameIndex >= 60) {
        wrapper.querySelector('.scroll-3').classList.add('visible');
      }
    }
  };
  
  prepareImages();
  
  window.addEventListener('scroll', () => {
    let scrollTop;
    let maxScrollTop;
    if (heroSequence) {
      scrollTop = document.documentElement.scrollTop - heroSequence.offsetTop;
      maxScrollTop = heroSequence.scrollHeight - window.innerHeight;
    } else if (xcSequence) {
      scrollTop = document.documentElement.scrollTop - xcSequence.offsetTop;
      maxScrollTop = xcSequence.scrollHeight - window.innerHeight;
    }
    let scrollFraction = scrollTop / maxScrollTop;
    scrollFraction = Math.min(1, Math.max(0, scrollFraction));
    
    const frameIndex = Math.max(0, Math.min(frameCount - 1, Math.ceil(scrollFraction * frameCount)));
  
    if (images[frameIndex].complete) {
      drawImage(frameIndex);
    } else {
      images[frameIndex].onload = () => drawImage(frameIndex);
    }
  
    updateContentVisibility(frameIndex);
    requestAnimationFrame(() => drawImage(frameIndex));
    
      const stickyElementTop = xcSequence.getBoundingClientRect().top;
      const stickyElementBottom = xcSequence.getBoundingClientRect().bottom;
      const windowHeight = window.innerHeight;
  
      // Check if the sticky element is at the top of the viewport
      if (stickyElementTop <= 0 && stickyElementBottom > windowHeight) {
          sticky.classList.add('sticky');
      } else {
          sticky.classList.remove('sticky');
      }
  
      // Check if the sticky element is at the bottom of the viewport
      if (stickyElementBottom <= 0 || stickyElementTop >= windowHeight) {
          sticky.classList.remove('sticky');
      }
  });
  
  if (images[0].complete) {
    drawImage(0);
    updateContentVisibility(0);
  }
}